import { render, staticRenderFns } from "./cardFailed.vue?vue&type=template&id=5d284a35"
import script from "./cardFailed.vue?vue&type=script&lang=js"
export * from "./cardFailed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports